import { Link } from 'react-router-dom'

// Catch-all route. Renders inside <AppShell> so the operator can
// navigate elsewhere without losing context.
export function NotFoundPage() {
  return (
    <div className="mx-auto max-w-xl p-12 text-center">
      <h1 className="text-2xl font-semibold text-stone-900">
        Not found
      </h1>
      <p className="mt-3 text-stone-600">
        The page you tried to reach doesn't exist in the admin console.
      </p>
      <Link
        to="/"
        className="mt-6 inline-block rounded-md bg-accent px-4 py-2 text-sm
                   font-medium text-white shadow-sm hover:bg-accent/90"
      >
        Back to Health overview
      </Link>
    </div>
  )
}
